import React from 'react';
import './Hero.css';
import heroImage from '../../assets/images/hero-handmade.png';

function Hero(): React.ReactElement {
  return (
    <section className="hero" id="home">
      <div className="hero-bg" style={{ backgroundImage: `url(${heroImage})` }} />
      <div className="hero-lightdrop" aria-hidden="true" />
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">Handmade with love</h1>
        <p className="hero-tagline">Cozy creations, crafted to comfort and charm.</p>
        <a href="#collections" className="cta-btn">Explore Crochet</a>
      </div>
    </section>
  );
}

export default Hero;
